import UploadField from './UploadField';
import { useContext, useMemo } from 'react';
import { OnSpotContextProps, OnSpotFileData } from '@/model/onSpot/OnSpot';
import { OnSpotContext } from '../../index';
import { TreeNode } from '@/model/onSpot/TreeNodes';

type UploadFieldSubBoxProps = {
    category: string;
    subCategory?: string;
    parentTreeId: string;
    node: TreeNode;
};

export const UploadFieldContainer = ({ parentTreeId, node, category, subCategory }: UploadFieldSubBoxProps) => {
    const { dataTree, displayedQuestions, treeSectionMapping, fileLists, setFileLists } = useContext(
        OnSpotContext
    ) as OnSpotContextProps;

    const categoryDbId = useMemo(() => {
        let categoryDbId;
        let subCategoryDbId;

        if (Object.keys(displayedQuestions).length === 1) {
            categoryDbId = displayedQuestions['entrypoint']?.[1]?.answers.find((answer) => answer.checked)?.dbId;
        }

        Object.keys(dataTree).forEach((question) => {
            dataTree[question].answers.forEach((answer) => {
                if (category === answer.id) {
                    categoryDbId = answer.dbId;
                }
                if (subCategory === answer.id) {
                    subCategoryDbId = answer.dbId;
                }
            });
        });

        return { category: categoryDbId ?? 0, subCategory: subCategoryDbId };
    }, [category, dataTree, displayedQuestions, subCategory]);

    const setUploadFiles = (id: string, fileList: OnSpotFileData[]) => {
        setFileLists({ ...fileLists, ...{ [id]: fileList } });
    };

    return (
        <>
            {parentTreeId !== node.treeId ? (
                <>
                    <h2 className="color-primary">{treeSectionMapping[parentTreeId]}</h2>
                    {parentTreeId !== node.treeId && (
                        <h3 className="color-primary">{treeSectionMapping[node.treeId]}</h3>
                    )}
                </>
            ) : (
                <h2 className="color-primary">
                    {Object.keys(displayedQuestions).length === 1
                        ? 'Nicht in gebuchter Unterkunft'
                        : treeSectionMapping[parentTreeId]}
                </h2>
            )}
            <div className="container">
                <UploadField
                    uniqueKey={`${node.treeId}-fault`}
                    category={categoryDbId.category}
                    subCategory={categoryDbId.subCategory}
                    uploadType="fault"
                    setUploadFiles={setUploadFiles}
                    fileData={fileLists[`${node.treeId}-fault`] || []}
                />
                <UploadField
                    uniqueKey={`${node.treeId}-general`}
                    category={categoryDbId.category}
                    subCategory={categoryDbId.subCategory}
                    uploadType="general"
                    setUploadFiles={setUploadFiles}
                    fileData={fileLists[`${node.treeId}-general`] || []}
                />
            </div>
        </>
    );
};
